import { render, staticRenderFns } from "./DateWidget.vue?vue&type=template&id=34c1a2c3&scoped=true&"
import script from "./DateWidget.vue?vue&type=script&lang=js&"
export * from "./DateWidget.vue?vue&type=script&lang=js&"
import style0 from "./DateWidget.vue?vue&type=style&index=0&id=34c1a2c3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c1a2c3",
  null
  
)

export default component.exports